import '../cart.js';
import 'slick-carousel';
import '../form.js';
import '../core/plugins/jquery.rating.pack.min.js';

$(document).ready(function () {
    //-- Rating
    $('.comment-rating').rating({
        callback: function (value, link) {
            $('#hdnCommentRating').val(value);
        },
    });

    if (typeof intStar !== "undefined" && intStar > 0) {
        $("#hdnCommentRating").val(intStar);
        $("a.btn-review").click();
    }

    $('input#btn-submit').click(function (event) {
        event.preventDefault();
        FormValidateReview($('form#frmReview'));
        var blnIsFormValid = $('form#frmReview').valid();
        if (blnIsFormValid) {
            turnstile.render('.g-recaptcha', {
                sitekey: WebsiteSettingStrRecaptchaSiteKey,
                callback: function () {
                    $('form#frmReview').submit();
                },
            });
        }
    });

    // Product with optionseries
    if (intProductPricetypeno == 2) {
        // Select another option
        $('select[name*="OptionSerie"]').change(function () {
            if ($(this).find(':selected').data('href')) {
                // Go to the url from the option
                document.location = $(this).find(':selected').data('href');
            }
        });
    }

    // Add to cart
    AddToCart($('form#frmAddToCart button#btnAddToCart'), WebsiteSettingBlnShowAddToCartQtyField, true, true);

    // Mail on stock
    if (WebsiteSettingBlnMailOnStock) {
        // Clicking on button from mail on stock => ajax form
        $('input#btnMailStock').click(function () {
            MailOnStock();
        });

        $('input#txtEmailStock').on('keyup', function (e) {
            if (e.which == 13) {
                MailOnStock();
                return false;
            }
        });
    }

    // Check if there are linked products with an add-to-cart button
    if (intSizeRelatedProducts > 0) {
        AddToCart($('form.form-add-to-cart button.btn-basket'), false, true);
    }

    //ADD TO WISHLIST
    $('#add-to-wishlist').click(function () {
        var strWishlistArticles = GetLocalStorage('strWishlistArticles');

        var strParams = 'intArticleno=' + $(this).data('article');
        strParams += '&strType=add';
        strParams += '&strWishlistArticles=' + strWishlistArticles;

        $.post(strAjaxPath + 'wishlist/wishlist.php', strParams, function (objResponse) {
            if (objResponse != '') {
                // Save session storage
                SetLocalStorage('strWishlistArticles', objResponse.articles);

                $.post(strAjaxPath + 'wishlist/wishlist-popup.php', strParams, function (data) {
                    $.fancybox.open(
                        data,
                        {
                            afterLoad: function () {
                                $('#add-to-wishlist i').addClass('text-warning');

                                // Click on link 'View wishlist'
                                $('#parent').click(function () {
                                    parent.window.location = $(this).attr('href');
                                    return false;
                                });

                                // Click on link 'Add new list'
                                $('#new-list').click(function () {
                                    $(this).toggleClass('active');
                                    $('form#frmWishlist').toggleClass('d-none');
                                    return false;
                                });

                                // Choose another list
                                $('input[type=radio]').click(function () {
                                    var strValue = $(this).val();
                                    var strParams = 'intArticleno=' + intArticleno;
                                    strParams += '&strGiftlistno=' + strValue;

                                    // Update wish list
                                    $.post(strAjaxPath + 'wishlist/wishlist-update-list.php', strParams, function (data) {
                                        if (data == 'OK') {
                                            $('#parent').attr('href', strPath + strLang + '-' + strBdLang + '/wishlist/' + strValue);
                                        }
                                    });
                                });

                                // Validate form
                                FormValidateAddWishlist($('form#frmWishlist'));
                            },
                        },
                    );
                });
            }
        }, 'json');
        return false;
    });
    if ($('.slider-row').length > 0) {
        var objSliderProducts = $('.slider-row').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 555,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    //slider
    if ($('.slider').length > 0) {
        var objSlider = $('.slider').slick({
            adaptiveHeight: true, //maek the height of the slider change to the height of the image
            autoplay: false, // automated sliding of the slider (only activate on client demand !!)
            arrows: false, // left and right arrow to navigate throug the slider
            dots: false, // navigation dots
            fade: false, // fade instead of slide,
            infinite: true, // make the slider infinite scrolling
        });

// Check the number of thumbs
//         var intThumbs = $('.img-thumbnail').length;
//         var thumbparent = $('.img-thumbnail').closest('div');

        // if (intThumbs > 1) {
        //     thumbparent.slick({
        //         slidesToShow: 5,
        //         slidesToScroll: 1,
        //         dots: false,
        //         focusOnSelect: true,
        //         prevArrow: '<button type=\'button\' class=\'slick-prev pull-left\'><i class=\'fa fa-angle-left\' aria-hidden=\'true\'></i></button>',
        //         // nextArrow: '<button type=\'button\' class=\'slick-next pull-right\'><i class=\'fa fa-angle-right\' aria-hidden=\'true\'></i></button>',
        //     });
        // }
        // thumbparent.on('click', '.slick-slide', function () {
        //     $('.img-thumbnail').removeClass('slick-current');
        //     $(this).addClass('slick-current');
        //     objSlider.slick('slickGoTo', $(this).attr('data-slick-index'));
        //     return false;
        // });
    }

    /** CUSTOM **/
    // Click on 'Pour qui' block in product detail
    $('#pour-qui-block').click(function () {
        // Get Pour qui wizard
        $.post(strAjaxPath + 'product/pour-qui/wizard.php', 'articleno=' + intArticleno, function (response) {
            // Add html to modal
            $('#pourQui .modal-body').html(response);
            $('#pourQui').modal('show');

            // Save item choice and set item selected (= green)
            PourQuiSaveChoice();

            // Next button
            // PourQuiNextStep();

            // Previous button
            // PourQuiPrevStep();

        }, 'html');

        return false;
    });

    // Check if wallet product
    if (intArticleno == WebsiteSettingIntProductWallet){
        // Click on 'Add' button to add a value to the wallet
        AddWalletToCart(strHrefPopupProductWalletAdded);
    }

    initDetailDescriptionToggle();

    /** END CUSTOM **/

    $('input#btnSubscribeSerie').click(function () {
        SubscribeSerie();
    });

});

function  initDetailDescriptionToggle() {
    const $container = $('.detail-description');
    const $button = $('[data-description-toggle]');
    const $showMore = $('[data-description-toggle-showmore]');
    const $showLess = $('[data-description-toggle-showless]');
    const $icon = $('[data-description-toggle-icon]');

    // Check if content exceeds max height
    function checkContentHeight() {
        const containerHeight = $container[0].scrollHeight;
        const maxHeight = parseInt($container[0].clientHeight);

        if (containerHeight > maxHeight) {
            $button.show();
            // Voeg class toe om het vervagingseffect te activeren
            $container.addClass('has-overflow');

        } else {
            $button.hide();
            // Verwijder class om het vervagingseffect te deactiveren
            $container.removeClass('has-overflow');

        }
    }

    // Toggle functionality
    $button.on('click', function() {
        const isExpanded = $container.hasClass('expanded');

        if (isExpanded) {
            // Collapse
            $container.removeClass('expanded');
            $showMore.removeClass('d-none');
            $showLess.addClass('d-none');
            $icon.removeClass('rotated');
            $container.addClass('has-overflow');

        } else {
            // Expand
            $container.addClass('expanded');
            $showMore.addClass('d-none');
            $showLess.removeClass('d-none');
            $icon.addClass('rotated');
            $container.removeClass('has-overflow');

        }
    });

    // Initialize
    checkContentHeight();

    // Re-check on window resize
    $(window).on('resize', function() {
        checkContentHeight();
    });
}

function onSubmitCaptcha(data) {
    $('form#frmReview').submit();
}

function MailOnStock() {
    var objInput = $('input#txtEmailStock');
    var objInputParent = objInput.parent();

    // Check if there's a correct e-mail entered => then add request to database
    $.post(strAjaxPath + 'mail-on-stock.php', 'intArticleNo=' + $('input#hdnArticleNo').val() + '&intPriceNo=' + $('input#hdnPriceNo').val() + '&strEmailStock=' + $('input#txtEmailStock').val(), function (data) {

        $('label[for="txtEmailStock"]').remove();
        objInput.removeClass('is-invalid');

        if (data.value == 0) {
            // Error
            objInput.addClass('is-invalid');
            objInputParent.append('<label class="d-flex invalid-feedback" for="txtEmailStock">' + data.message + '</label>');
        } else {
            // Notitication
            objInputParent.parent().hide();
            objInputParent.parent().parent().append('<div class="alert alert-success">' + data.message + '</div>');
        }
    }, 'json');
}

function SubscribeSerie() {
    var objInput = $('input#btnSubscribeSerie');
    var objInputParent = objInput.parent();

    objInput.prop('disabled', true);

    // Check if there's a correct e-mail entered => then add request to database
    $.post(strAjaxPath + 'product-subscription.php', 'intSerieNo=' + $('input#hdnSerieNo').val() + '&intCoverNo=' + $('input#hdnIntCoverNo').val() + '&strLang=' + $('input#hdnStrLang').val(), function (data) {
        if (data.value == 1) {
            objInput.hide();
            objInputParent.append('<div class="alert alert-success">' + data.message + '</div>');
        } else {
            objInput.hide();
            objInputParent.append('<div class="alert alert-danger">' + data.message + '</div>');
        }
    }, 'json');
}

/** CUSTOM **/
// Pour qui: save item choice (category or product) and set right item selected
function PourQuiSaveChoice() {
    // Click on an item (category or product)
    $('a[data-type="item-block"]').click(function () {
        $(this).off('click', '**');
        var objItemBlock = $(this);
        var intStep = objItemBlock.data('step');
        $.post(strAjaxPath + 'product/pour-qui/wizard-save-choice.php', 'articleno=' + intArticleno + '&item=' + objItemBlock.data('key') + '&parent=' + objItemBlock.data('parent') + '&step=' + intStep + '&stepTitle=' + $('#step-title').text() + '&type=' + objItemBlock.data('catprod'), function (responseChoice) {

            // Check if another item was already selected
            objItemBlock.closest('div.row').find('a.selected').each(function () {
                if ($(this).data('key') != objItemBlock.data('key')) {
                    var objOtherBlock = $(this);
                    // Deselect other item
                    objOtherBlock.removeClass('selected');
                    objOtherBlock.addClass('bg-secondary').removeClass('bg-success').addClass('text-black').removeClass('text-white');
                    if (objOtherBlock.find('img[data-type="image-selected"]').length) {
                        objOtherBlock.find('img[data-type="image-unselected"]').addClass('d-inline-block').removeClass('d-none');
                        objOtherBlock.find('img[data-type="image-selected"]').removeClass('d-inline-block').addClass('d-none');
                    }
                    objOtherBlock.find('[data-type="choice-bottom-unselected"]').addClass('d-inline-block').removeClass('d-none');
                    objOtherBlock.find('[data-type="choice-bottom-selected"]').addClass('d-none');
                    if ($('[data-type="btn-next"][data-key="' + objOtherBlock.data('key') + '"]').length) {
                        $('[data-type="btn-next"][data-key="' + objOtherBlock.data('key') + '"]').removeClass('d-flex').addClass('d-none');
                    }
                }
            });

            objItemBlock.addClass('selected');
            // Set choosen item green
            objItemBlock.removeClass('bg-secondary').addClass('bg-success').removeClass('text-black').addClass('text-white');
            // Show hover image (if there is one)
            if (objItemBlock.find('img[data-type="image-selected"]').length) {
                objItemBlock.find('img[data-type="image-unselected"]').removeClass('d-inline-block').addClass('d-none');
                objItemBlock.find('img[data-type="image-selected"]').addClass('d-inline-block').removeClass('d-none');
            }
            // Show check icon/hide 'choose' button
            objItemBlock.find('[data-type="choice-bottom-unselected"]').removeClass('d-inline-block').addClass('d-none');
            objItemBlock.find('[data-type="choice-bottom-selected"]').removeClass('d-none');

            // Show right next button
            $('[data-type="btn-next"]').data('next-type', responseChoice.arrNextStep.type);
            $('[data-type="btn-next"]').data('next-category', responseChoice.arrNextStep.categoryno);
            //$('[data-type="btn-next"]').data('next-step', (intStep * 1 + 1));
            $('[data-type="btn-next"]').find('#next-title').text(responseChoice.arrNextStep.name);
            $('[data-type="btn-next"]').addClass('d-inline-block').removeClass('d-none');

            // Next button
            PourQuiNextStep();
        }, 'json');

    });
}

// Pour qui: show next step after clicking on next button
function PourQuiNextStep() {
    // Click on next button
    $('a[data-type="btn-next"]').click(function () {
        $(this).off('click', '**');
        var intNextStep = $(this).data('next-step');
        var strNextType = $(this).data('next-type');

        // Check if next step is 'add to cart'
        if (strNextType == 'add-to-cart') {
            var strParams = $('form#frmMessage').serialize();
            strParams += '&articleno=' + intArticleno + '&step=' + (intNextStep - 1);
            $.post(strAjaxPath + 'product/pour-qui/wizard-add-to-cart.php', strParams, function (responseAddToCart) {
                // Get next step
                $.post(strAjaxPath + 'product/pour-qui/wizard-step.php', 'articleno=' + intArticleno + '&type=confirmation&step=' + intNextStep, function (responseStep) {
                    // Show next step in popup
                    $('div#step-wrapper').html(responseStep);

                    // Select right step left
                    PourQuiSetRightStepSelected(intNextStep);
                });
            }, 'json');

            return false;
        }

        // Get next step
        $.post(strAjaxPath + 'product/pour-qui/wizard-step.php', 'articleno=' + intArticleno + '&type=' + strNextType + '&categoryno=' + $(this).data('next-category') + '&step=' + intNextStep, function (responseStep) {
            // Show next step in popup
            $('div#step-wrapper').html(responseStep);

            // Select right step left
            PourQuiSetRightStepSelected(intNextStep);

            if (strNextType == 'category') {
                // Click on an item (category or product)
                // Save item choice and set item selected (= green)
                PourQuiSaveChoice();

                // Previous button
                PourQuiPrevStep();
            } else if (strNextType == 'message') {
                // Show right next button
                $('[data-type="btn-next"]').data('next-type', 'add-to-cart');
                $('[data-type="btn-next"]').data('next-category', 0);
                //$('[data-type="btn-next"]').data('next-step', (intStep * 1 + 1));
                $('[data-type="btn-next"]').find('#next-title').text(strLabelAddToCart);
                $('[data-type="btn-next"]').addClass('d-inline-block').removeClass('d-none');

                // Click on next button (to add this to cart)
                PourQuiNextStep();

                // Previous button
                PourQuiPrevStep();
            }
        }, 'html');
    });
}

// Pour qui: set right step selected (numbers left)
function PourQuiSetRightStepSelected(intStep) {
    $('[data-type="steps"]').children('span').each(function () {
        if ($(this).data('step') < intStep) {
            $(this).addClass('passed');
            $(this).find('i').removeClass('text-success').removeClass('text-gray-300').addClass('text-black');
        } else if ($(this).data('step') == intStep) {
            $(this).removeClass('passed');
            $(this).find('i').addClass('text-success').removeClass('text-gray-300').removeClass('text-black');
        } else {
            $(this).removeClass('passed');
            $(this).find('i').removeClass('text-success').addClass('text-gray-300').removeClass('text-black');
        }
    });
}

// Pour qui: show previous step after clicking on previous button
function PourQuiPrevStep() {
    // Click on previous button
    $('a[data-type="btn-prev"]').click(function () {
        $(this).off('click', '**');
        var intPrevStep = $(this).data('prev-step');
        var strPrevType = $(this).data('prev-type');

        // Get previous step
        $.post(strAjaxPath + 'product/pour-qui/wizard-step.php', 'articleno=' + intArticleno + '&type=' + strPrevType + '&categoryno=' + $(this).data('prev-category') + '&step=' + intPrevStep, function (responseStep) {
            // Show previous step in popup
            $('div#step-wrapper').html(responseStep);

            // Select right step left
            PourQuiSetRightStepSelected(intPrevStep);

            if (strPrevType == 'category' || strPrevType == 'product') {
                // Click on an item (category or product)
                // Save item choice and set item selected (= green)
                PourQuiSaveChoice();
            } else if (strPrevType == 'message') {
                // Show right next button
                $('[data-type="btn-next"]').data('next-type', 'add-to-cart');
                $('[data-type="btn-next"]').data('next-category', 0);
                //$('[data-type="btn-next"]').data('next-step', (intStep * 1 + 1));
                $('[data-type="btn-next"]').find('#next-title').text(strLabelAddToCart);
                $('[data-type="btn-next"]').addClass('d-inline-block').removeClass('d-none');
            }

            // Next button
            PourQuiNextStep();

            // Previous button
            PourQuiPrevStep();
        }, 'html');
    });
}

/** END CUSTOM **/

window.onSubmitCaptcha = onSubmitCaptcha;
